"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var columns = [
    index_1.AnalyteColumn,
    index_1.LODColumnFactory({
        solidDisplayUnits: "mg/g",
        volumeDisplayUnits: "mg/mL",
    }),
    index_1.LOQColumnFactory({
        solidDisplayUnits: "mg/g",
        volumeDisplayUnits: "mg/mL",
    }),
    index_1.DefaultResultsColumnFactory({
        solidDisplayUnits: "mg/g",
        volumeDisplayUnits: "mg/mL",
        precision: 2,
    }),
    index_1.ResultsPercentageColumnFactory({ precision: 3 }),
];
exports.default = columns;
//# sourceMappingURL=columns.js.map